import React, { useState } from 'react'

import { PlusOutlined, UploadOutlined, QuestionCircleFilled } from '@ant-design/icons'
import { Button, Tooltip } from 'antd'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { useOperatorNotification } from '@contexts/operator/OperatorNotificationContext'
import OperatorBundleConceptModal from '@shared/bundles/OperatorBundleConceptModal'
import ListPageHeader from '@shared/ListPageHeader'
import BundlesListView from '@shared/bundles/BundlesListView'
import Can from '@shared/permissions/Can'

import { bundleService } from '@services/operator/bundleService'

const OperatorBundlesList: React.FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { addJob } = useOperatorNotification() as { addJob: (jobId: string, jobName: string) => void }
  const [importModalVisible, setImportModalVisible] = useState(false)
  const [conceptModalVisible, setConceptModalVisible] = useState(false)

  return (
    <div>
      <ListPageHeader
        items={['products', 'products.bundles']}
        guideButton={
          <Tooltip title={t('concepts.bundles_operator.tooltip')}>
            <Button
              type="text"
              size="small"
              icon={<QuestionCircleFilled style={{ color: '#1890ff' }} />}
              onClick={() => setConceptModalVisible(true)}
              style={{ padding: 0, height: 'auto', minWidth: 'auto' }}
            />
          </Tooltip>
        }
        actions={
          <>
            <Can requiredPermission="products:write">
              <Button icon={<UploadOutlined />} onClick={() => setImportModalVisible(true)}>
                {t('common.button.import')}
              </Button>
            </Can>
            <Can requiredPermission="products:write">
              <Button type="primary" icon={<PlusOutlined />} onClick={() => navigate('/bundles/new')}>
                {t('common.button.new')}
              </Button>
            </Can>
          </>
        }
      />
      <BundlesListView
        role="operator"
        service={bundleService}
        addJob={addJob}
        importModalVisible={importModalVisible}
        setImportModalVisible={setImportModalVisible}
      />
      <OperatorBundleConceptModal
        visible={conceptModalVisible}
        onClose={() => setConceptModalVisible(false)}
      />
    </div>
  )
}

export default OperatorBundlesList
